<app-list-header [headerName]="'Все уроки'"></app-list-header>
<app-lessons-list
        [studentClassId]="classId"
        [showHeader]="true"
        *ngIf="classId">
</app-lessons-list>